import { Calendar, Download } from 'lucide-react';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ExportCalendarButton = ({ eventId, eventTitle, genre, city }) => {
  const handleExportSingle = () => {
    window.open(`${API}/events/${eventId}/ical`, '_blank');
  };

  const handleExportByGenre = () => {
    window.open(`${API}/events/export/ical?genre=${genre}`, '_blank');
  };

  const handleExportByCity = () => {
    window.open(`${API}/events/export/ical?city=${encodeURIComponent(city)}`, '_blank');
  };

  const handleExportAll = () => {
    window.open(`${API}/events/export/ical`, '_blank');
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className="btn-outline flex items-center gap-2"
          data-testid="export-calendar-btn"
        >
          <Calendar size={16} />
          Añadir al Calendario
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-[var(--surface)] border-white/10">
        <DropdownMenuItem 
          onClick={handleExportSingle}
          className="text-white hover:bg-white/10 cursor-pointer"
          data-testid="export-single"
        >
          <Download size={14} className="mr-2" />
          Este evento
        </DropdownMenuItem>
        {genre && (
          <DropdownMenuItem 
            onClick={handleExportByGenre}
            className="text-white hover:bg-white/10 cursor-pointer"
            data-testid="export-by-genre"
          >
            <Download size={14} className="mr-2" />
            Todos los eventos de {genre}
          </DropdownMenuItem>
        )}
        {city && (
          <DropdownMenuItem 
            onClick={handleExportByCity}
            className="text-white hover:bg-white/10 cursor-pointer"
            data-testid="export-by-city"
          >
            <Download size={14} className="mr-2" />
            Todos los eventos en {city}
          </DropdownMenuItem>
        )}
        <DropdownMenuItem 
          onClick={handleExportAll}
          className="text-white hover:bg-white/10 cursor-pointer"
          data-testid="export-all"
        >
          <Download size={14} className="mr-2" />
          Todos los eventos
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ExportCalendarButton;
